import {
	Checkbox,
	List,
	ListItem,
	ListItemText,
	ListSubheader,
	ListItemSecondaryAction,
} from '@mui/material';

import { useEffect, useState } from 'react';

import { scrollProps } from 'common/utils/utilFunctions';

import { IModulePermissionResponseList } from '../api/type-def';

import styles from './DataAccessPermissions.module.scss';

interface IPermissionsModules {
	selectedModules: IModulePermissionResponseList[];
	onModuleSelect: (data: IModulePermissionResponseList[]) => void;
	data: IModulePermissionResponseList[];
	clearButton: boolean;
	selectButton: boolean;
}
const PermissionsModules = (props: IPermissionsModules) => {
	const { data, selectedModules, onModuleSelect, clearButton, selectButton } =
		props;
	const { checkboxUncheckedcolor, checkboxCheckedcolor } = styles;

	const [selectedModulesData, setSelectedModulesData] = useState<
		IModulePermissionResponseList[]
	>([]);
	const [selectedModuleIds, setSelectedModuleIds] = useState<string[]>([]);
	const allModules = data;

	const handleChange = (idata: IModulePermissionResponseList) => {
		if (selectedModulesData && selectedModulesData.length > 0) {
			const selectedModuleIDS = selectedModulesData.map(
				(ele: IModulePermissionResponseList) => ele.moduleId,
			);
			if (selectedModuleIDS.indexOf(idata.moduleId) > -1) {
				setSelectedModulesData((prevState: IModulePermissionResponseList[]) => {
					let prevData = [...prevState];
					prevData = prevData.filter(
						(ele: IModulePermissionResponseList) =>
							idata.moduleId !== ele.moduleId,
					);
					return prevData;
				});

				setSelectedModuleIds((prev: any) => {
					let prevData = [...prev];
					prevData = prevData.filter((ele: string) => ele !== idata.moduleId);
					return prevData;
				});
			} else {
				updateModulesData(idata);
				updateIds(idata);
			}
		} else {
			updateModulesData(idata);
			updateIds(idata);
		}
	};

	const updateIds = (idata: any) => {
		setSelectedModuleIds((prev: any) => {
			const prevData = [...prev];
			const updatedData = prevData.concat(idata.moduleId);
			return updatedData;
		});
	};

	const updateModulesData = (idata: any) => {
		setSelectedModulesData((prev: any) => {
			let prevData = [...prev];
			prevData = prevData.filter((ele: any) => ele.moduleId !== idata.moduleId);
			const updatedData = prevData.concat(idata);
			return updatedData;
		});
	};

	const clearAllModules = () => {
		setSelectedModulesData([]);
		setSelectedModuleIds([]);
		onModuleSelect([]);
	};
	const selectAllModules = () => {
		setSelectedModulesData([]);
		setSelectedModuleIds([]);
		setSelectedModulesData(data);
		const selectedIDS = data.map(
			(ele: IModulePermissionResponseList) => ele.moduleId,
		);
		setSelectedModuleIds(selectedIDS);
		onModuleSelect(data);
	};
	useEffect(() => {
		onModuleSelect(selectedModulesData);
	}, [selectedModulesData]);

	useEffect(() => {
		if (clearButton) {
			clearAllModules();
		}
	}, [clearButton]);

	useEffect(() => {
		if (selectButton) {
			selectAllModules();
		}
	}, [selectButton]);

	useEffect(() => {
		if (selectedModules && selectedModules.length > 0) {
			selectedModules.forEach((ele: any) => {
				const ids = selectedModuleIds;
				if (ids.indexOf(ele?.moduleId) === -1) {
					updateModulesData(ele);
					updateIds(ele);
				}
			});
		}
	}, [selectedModules && selectedModules.length]);

	return (
		<List
			dense
			data-testid="main-list"
			className={styles['permission-modules-list']}
			sx={scrollProps()}
			subheader={
				<ListSubheader className={styles['permission-modules-sublist']}>
					<ListItem disablePadding>
						<ListItemText
							id="name"
							primary="Module"
							className={styles['permission-modules-sublistwidth']}
						/>
						<ListItemText
							id="access"
							primary="Access"
							className={styles['permission-modules-sublistwidth']}
						/>
					</ListItem>
				</ListSubheader>
			}
		>
			{allModules &&
				allModules.length > 0 &&
				allModules.map((ele: any) => {
					const labelId = `checkbox-list-secondary-label-${ele.moduleId}`;
					return (
						<ListItem
							className={styles['permission-modules-listwidth']}
							disablePadding
							key={labelId}
							data-testid="list-items"
						>
							<ListItemText
								className={styles['permission-modules-text']}
								id={labelId}
								primary={ele.moduleName}
							/>
							<ListItemSecondaryAction
								className={styles['permission-modules-checkbox']}
							>
								<Checkbox
									onChange={() => {
										handleChange(ele);
									}}
									checked={selectedModuleIds.indexOf(ele.moduleId) !== -1}
									inputProps={{ 'aria-labelledby': labelId }}
									data-testid="checkbox-modules"
									sx={{
										color: checkboxUncheckedcolor,
										'&.Mui-checked': { color: checkboxCheckedcolor },
										'&.MuiCheckbox-indeterminate': {
											color: checkboxCheckedcolor,
										},
									}}
								/>
							</ListItemSecondaryAction>
						</ListItem>
					);
				})}
		</List>
	);
};

export default PermissionsModules;
